import { Component, Input, OnInit } from '@angular/core';
import { MenuStructure, MenuGroup, MenuItem, ExternalLink } from '../../core/models/menu.models';
import { LiteralsFacadeService } from '../../shared/services/literals.facade.service';
import { RolesFacadeService } from '../../shared/services/roles.facade.service';

@Component({
  selector: 'app-sidebar-menu',
  templateUrl: './sidebar-menu.component.html',
  styleUrls: ['./sidebar-menu.component.scss'],
  standalone: false,
})
export class SidebarMenuComponent implements OnInit {
  @Input() menuConfig: MenuStructure = [];

  literals: any = {};
  roles: any = {};

  constructor(
    private literalsFacade: LiteralsFacadeService,
    private rolesFacade: RolesFacadeService,
  ) {}

  ngOnInit(): void {
    this.literalsFacade.literals$.subscribe((state) => {
      this.literals = state?.literals || {};
    });

    this.rolesFacade.roles$.subscribe((state) => {
      this.roles = state?.roles || {};
    });
  }

  translate(key: string): string {
    return this.literals[key] || key;
  }

  hasRole(role: string): boolean {
    return Object.keys(this.roles).includes(role);
  }

  visibleItems(items: MenuItem[]): MenuItem[] {
    return items.filter((item) => this.hasRole(item.role));
  }

  visibleLinks(links: ExternalLink[]): ExternalLink[] {
    return links.filter((link) => this.hasRole(link.role));
  }

  isGroupVisible(group: MenuGroup): boolean {
    return this.visibleItems(group.items).length > 0 || this.visibleLinks(group.links).length > 0;
  }
}
